import React from 'react';
import PropTypes from 'prop-types';

// Components
import {
  Heading,
  TextInput,
  Button,
  Link,
  CollapsedContent,
} from 'components';

// Style
import classNames from 'classnames/bind';
import styles from '../styles.pcss';
const cx = classNames.bind(styles);

const ConnectStep = ({
  openDeleteNumber,
  openConfirm,
  onChange,
  data: {
    title,
    buttonText,
    beforeContent,
    deleteText,
    collapsedButtonText,
    collapsedContent,
    afterContent,
    disabled,
    msg,
  },
}) => (
  <div>
    {title && (
      <Heading level={1} isStyled={false}>
        <span dangerouslySetInnerHTML={{ __html: title }} />
      </Heading>
    )}
    <div className={cx('content')}>
      {beforeContent && (
        <p dangerouslySetInnerHTML={{ __html: beforeContent }} />
      )}

      {/** Форма добавления/отправки номера */}
      <div className={cx('form')}>
        <div className={cx('smartInput')}>
          <TextInput
            className={cx('formInput')}
            size="big"
            mask="+7 ___ ___ __ __"
            value="+7 "
            status={msg && 'fail'}
            msg={msg}
            onChange={onChange}
          />
          {msg && (<span className={cx('message')}>{msg}</span>)}
        </div>
        <Button
          className={cx('big')}
          onClick={openConfirm}
          disabled={!disabled}
          transformer
        >
          {buttonText}
        </Button>
      </div>

      {deleteText && (
        <div className={cx('delNumber')}>
          {deleteText[0]}
          <Link onClick={openDeleteNumber}>удалить</Link>
          {deleteText[1]}
        </div>
      )}

      {/** Скрытый кондент */}
      {collapsedContent && (
        <CollapsedContent
          title={collapsedButtonText}
        >
          <div dangerouslySetInnerHTML={{ __html: collapsedContent }} />
        </CollapsedContent>
      )}

      {afterContent && (
        <p dangerouslySetInnerHTML={{ __html: afterContent }} />
      )}
    </div>
  </div>
);

ConnectStep.propTypes = {
  openDeleteNumber: PropTypes.func,
  openConfirm: PropTypes.func,
  onChange: PropTypes.func,
  data: PropTypes.shape({
    title: PropTypes.string,
    beforeContent: PropTypes.string,
    buttonText: PropTypes.string,
    deleteText: PropTypes.string,
    collapsedButtonText: PropTypes.string,
    collapsedContent: PropTypes.string,
    afterContent: PropTypes.string,
    disabled: PropTypes.bool,
    msg: PropTypes.string,
  }),
};

export default ConnectStep;
